<template>
  <div
    v-if="isVisible"
    class="form-error-list"
  >
    <ul class="list form-error-list__items">
      <template v-for="(message, key) in messages">
        <li
          :key="key"
          class="list__element list__element--dashed form-error-list__item error-message"
          v-html="message"
        />
      </template>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed, withDefaults } from 'vue';
import { forIn, isArray, flattenDeep, uniq } from 'lodash-es';

function collectMessages(messages) {
  if (!messages) return [];
  const collectedMessages = [];
  if (!isArray(messages)) {
    forIn(messages, (message) => {
      collectedMessages.push(collectMessages(message));
    });
  } else {
    collectedMessages.push(messages);
  }
  return uniq(flattenDeep(collectedMessages));
}

export type FormErrorListProps = {
  errors?: string[] | Record<string, string>;
};

const props = withDefaults(defineProps<FormErrorListProps>(), {
  errors: undefined,
});

const messages = computed(() => collectMessages(props.errors));

const isVisible = computed(() => messages.value.length > 0);

defineExpose({
  isVisible,
  messages,
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.form-error-list {
  padding-top: 1.5 * $grid-base;
  padding-bottom: 1.5 * $grid-base;

  @include mq($mq-sm) {
    padding-top: 2.5 * $grid-base;
    padding-bottom: 2.5 * $grid-base;
  }
}
</style>
